import {useDYUserStore} from "~/modules/nuxt3-module-doyac/stores/user";
import { useDYAppConfig } from "./config";

export function useAppLinkHandler(androidPackageName: string, appRequired: boolean) {
  const { siteName, dbDomain, IOS_APP_STORE_ID, DYNAMIC_LINK_BASE_URL } = useDYAppConfig()
  const userStore = useDYUserStore()
  if (appRequired === undefined) appRequired = false;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const platform = navigator?.userAgent
  const userAgent = platform?.toLocaleLowerCase();

  function _isChrome() {
    return userAgent.search("chrome") > -1
  }

  function _isAndroid() {
    return userAgent.search("android") > -1
  }

  function _handleAndroid(appLinkUrl:string, fromDynamicLink: string) {
    const timeout = 1500;
    let timer: ReturnType<typeof setTimeout> | null = null;

    // visibilitychange 이벤트 핸들러
    const onVisibilityChange = () => {
      // 앱이 실행되어 브라우저가 백그라운드로(hidden) 전환되면 타이머 해제
      if (document.hidden && timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener('visibilitychange', onVisibilityChange);

    const fallbackFunction = function () {
      // 실행 시점에 리스너 정리
      document.removeEventListener('visibilitychange', onVisibilityChange);

      // 이미 앱이 떠서 화면이 가려진 상태라면 이동하지 않음
      if (document.hidden) return;

      if (appRequired) window.location.replace('market://details?id=' + androidPackageName);
      else window.location.replace(appLinkUrl);
    };

    const runScheme = function () {
      if (_isChrome()) {
        const url = _toIntentScheme(appLinkUrl, fromDynamicLink);
        // location.replace 대신 href 사용 (히스토리 이슈 및 intent 동작 안정성)
        window.location.href = url;
      } else {
        const iframe = document.createElement("iframe");
        iframe.style.border = "none";
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.src = appLinkUrl;
        document.body.appendChild(iframe);
      }
    };

    runScheme();
    timer = setTimeout(fallbackFunction, timeout);
  }

  function _handleIOS(appLinkUrl:string, fromDynamicLink: string) {
    const timeout = 1500;
    let timer: ReturnType<typeof setTimeout> | null = null;

    // 유니버셜 링크는 앱 미설치 시 웹으로 이동해버려 폴백 처리가 어려우므로 Custom Scheme 사용
    // 안드로이드와 동일하게 dbDomain을 스킴으로 사용 (예: doyac://open.main/...)
    const customScheme = `${dbDomain}://open.main/${fromDynamicLink}`;
    const appStoreUrl = `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`;

    const onVisibilityChange = () => {
      if (document.hidden && timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    const fallbackFunction = function () {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (document.hidden) return;

      if (appRequired) window.location.replace(appStoreUrl);
      else window.location.replace(appLinkUrl);
    };

    window.location.href = customScheme;
    timer = setTimeout(fallbackFunction, timeout);
  }

  function _toIntentScheme(appLinkUrl:string, fromDynamicLink: string) {
    if (appLinkUrl.indexOf("://") === -1)
      appLinkUrl = location.origin + appLinkUrl;

    const tokens = appLinkUrl?.split("://")
    const scheme = tokens[0];

    const url = new URL(appLinkUrl.replace(scheme + "://", "http://"));
    const host = url.host;

    // 마퍼가는 아직 플러터 앱이 출시되지 않았음. 따라서 구방식을 씀.
    return `intent://open.main/${fromDynamicLink}#Intent;scheme=${dbDomain};package=${androidPackageName};end;`;
  }

  const open = (appLinkUrl:string, fromDynamicLink: string) => {
    if (_isAndroid() && !userStore.isAndroidApp) {
      _handleAndroid(appLinkUrl, fromDynamicLink);
    } else if (userStore.isIOS && !userStore.isIOSApp) {
      _handleIOS(appLinkUrl, fromDynamicLink);
    } else {
      location.replace(appLinkUrl);
    }
  }

  return {
    open
  }
}